import { api, apis } from 'api';
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { AutoSizer } from 'react-virtualized/dist/commonjs/AutoSizer';
import styles from './index.module.scss';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { useAppSelector } from '@web-common/state/createStore';
import AccountTree, { treeRootKey } from './AccountTree';
import { getMainAccount } from '@web-mail/util';
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const productApi = api.requireLogicalApi(apis.productAuthApiImpl);
const mockData = [
    {
        id: 'wuxian02@lingxi.devtest.com',
        emailType: 'NeteaseQiYeMail',
        agentEmail: 'wuxian02@lingxi.devtest.com',
        accountType: 'mainAccount',
        mainAccount: 'wuxian02@lingxi.devtest.com',
    },
    {
        id: 'wuxian03@lingxi.devtest.com',
        emailType: 'NeteaseQiYeMail',
        agentEmail: 'wuxian03@lingxi.devtest.com',
        accountType: 'qyEmail',
        mainAccount: 'wuxian03@lingxi.devtest.com',
    },
];
export const createAccountRootKey = (key) => {
    return key + '_root';
};
export default (props) => {
    const { onExpand, useEdm, useMultiAccount, accountRootKey, type: propsType = ['personal', 'enterprise', 'team', 'recent'], noRelateEnterprise, showSeparator, showOrgMemberNum, } = props;
    const currentAccount = getMainAccount();
    const writeMailCurAccount = useAppSelector(state => { var _a; return (_a = state.mailReducer.currentMail) === null || _a === void 0 ? void 0 : _a.optSender; });
    const [activeAccountKey, setActiveAccountKey] = useState(createAccountRootKey(accountRootKey || currentAccount));
    const [accountList, setAccountList] = useState([]);
    let type = propsType;
    if (useEdm) {
        const temp = new Set(['customer', ...propsType]);
        type = [...temp];
    }
    const contactTreeDecorateMap = useMemo(() => {
        const separatorKeys = [...treeRootKey];
        const decorateMap = new Map();
        showSeparator &&
            separatorKeys.forEach(item => {
                decorateMap.set(item, new Map([
                    [
                        'rootSeparator',
                        {
                            element: (React.createElement("div", { className: styles.nodeSeparator },
                                ' ',
                                React.createElement("div", { className: styles.nodeSeparatorLine }),
                                ' ')),
                            height: 17,
                            distance: -1,
                        },
                    ],
                ]));
            });
        return decorateMap;
    }, [showSeparator]);
    const treeContent = useCallback((treeWidth, treeHeight) => {
        if (useMultiAccount && accountList.length > 1) {
            const accountLen = accountList.length - 1;
            const height = treeHeight - (accountLen + 1) * 32;
            return (React.createElement(React.Fragment, null, accountList.map(item => {
                const { id: account, emailType, agentEmail, accountType } = item;
                const isMainAccount = accountType === 'mainAccount';
                const isQyAccount = accountType === 'qyEmail';
                const showRecent = type.includes('recent');
                const showPersonal = type.includes('personal');
                const showTeam = type.includes('team') && isMainAccount;
                const showEnterprise = type.includes('enterprise') && (isMainAccount || isQyAccount);
                const resType = [];
                if (showPersonal) {
                    resType.push('personal');
                }
                if (showEnterprise) {
                    resType.push('enterprise');
                }
                if (showRecent) {
                    resType.push('recent');
                }
                if (showTeam) {
                    resType.push('team');
                }
                return (React.createElement(React.Fragment, null,
                    React.createElement(AccountTree, Object.assign({}, props, { isSingleAccount: false, type: resType, showSeparator: false, treeWidth: treeWidth, treeHeight: height, _account: account, accountRootKey: createAccountRootKey(account), accountType: emailType, rootTitle: agentEmail, onExpand: (type, isOpen) => {
                            setActiveAccountKey(createAccountRootKey(account));
                            onExpand && onExpand(type, isOpen);
                        }, activeAccountKey: activeAccountKey, noRelateEnterprise: noRelateEnterprise }))));
            })));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(AccountTree, Object.assign({}, props, { isSingleAccount: true, type: type, accountRootKey: createAccountRootKey(accountRootKey || currentAccount), _account: accountRootKey || currentAccount, contactTreeDecorateMap: contactTreeDecorateMap, noRelateEnterprise: noRelateEnterprise, treeWidth: treeWidth, treeHeight: treeHeight }))));
    }, [accountList, type, activeAccountKey, props.defaultSelectList, props.disableCheckList]);
    const getAccountList = useCallback(() => {
        accountApi
            .getMainAndSubAccounts({ expired: false })
            .then(res => {
            setAccountList(res);
        })
            .catch(err => {
            console.error('[contact tree] getMainAndSubAccounts error', err);
        });
    }, [setAccountList]);
    useEffect(() => {
        getAccountList();
    }, []);
    useMsgRenderCallback('SubAccountWindowReady', () => {
        getAccountList();
    });
    useMsgRenderCallback('SubAccountLoginExpired', () => {
        getAccountList();
    });
    useMsgRenderCallback('SubAccountDeleted', () => {
        getAccountList();
    });
    useEffect(() => {
        writeMailCurAccount && setActiveAccountKey(createAccountRootKey(writeMailCurAccount === null || writeMailCurAccount === void 0 ? void 0 : writeMailCurAccount.id));
    }, [writeMailCurAccount]);
    return (React.createElement("div", { className: styles.treeWrap },
        React.createElement(AutoSizer, { style: { width: '100%', height: '100%' } }, ({ width, height }) => {
            return treeContent(width, height);
        })));
};
